import styled from 'styled-components';

export const HomeContainer = styled.div`
    margin-top: 30%;
`
export const Title = styled.h1`
    text-align: center;
    font-family: 'Tiro Devanagari Marathi', serif;
    color: white;
    font-size: 100px;
    @media screen and (max-width: 800px) {
        font-size: 45px;
    }
`